<template>
  <el-header v-if="$store.state.user" class="nav-container">
    <el-menu
      mode="horizontal"
      background-color="#0c0526"
      text-color="#fff"
      active-text-color="#fff"
      router
    >
      <el-menu-item class="logo">
        <div id="bars" class="mobile-menu-toggle" @click="toggle()">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </el-menu-item>
      <el-menu-item @click.native="openDashboard">
        <img id="logo" src="@/assets/images/logo.svg" @click="openDashboard" />
      </el-menu-item>
      <el-tooltip
        class="item float-right log-out"
        effect="dark"
        content="Log Out"
        placement="bottom"
      >
        <el-menu-item class="float-right" @click.native="labelLogout">
          <i class="fas fa-sign-out-alt"></i>
        </el-menu-item>
      </el-tooltip>
      <el-menu-item class="float-right username-nav">
        {{ user.surname }}, {{ user.first_name }}
      </el-menu-item>
      <el-tooltip class="artists-dropdown" placement="top" trigger="hover">
        <div slot="content">
          <div v-for="artist in artists" :key="artist.id">
            <p class="artists-link" @click="openArtist(artist)">
              {{ artist.id ? artist.name : 'No Artist' }}
            </p>
          </div>
        </div>
        <el-menu-item
          class="float-right my-artists"
          @click.native="openArtists()"
        >
          <el-button
            class="edit"
            circle
            :style="[
              $route.path.includes('/label/my-artists/artist')
                ? { background: '#605677' }
                : { background: '#D40C41' }
            ]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.263"
              height="13.457"
              viewBox="0 0 18.263 13.457"
            >
              <path
                id="Icon_material-queue-music"
                data-name="Icon material-queue-music"
                d="M16.035,9H4.5v1.922H16.035Zm0,3.845H4.5v1.922H16.035ZM4.5,18.612h7.69V16.69H4.5ZM17.957,9v7.863a2.879,2.879,0,1,0,1.922,2.711V10.922h2.884V9Z"
                transform="translate(-4.5 -9)"
                fill="#fff"
              />
            </svg>
          </el-button>
          <span class="text">My Artists</span>
          <i class="el-icon-arrow-down"></i>
        </el-menu-item>
      </el-tooltip>
      <li class="nav-search">
        <div @keydown.stop>
          <el-autocomplete
            v-model="search"
            :fetch-suggestions="remoteMethod"
            :trigger-on-focus="false"
            @select="handleSelect"
            :debounce="500"
            prefix-icon="el-icon-search"
            placeholder="Search artist or track"
            :maxlength="100"
          >
            <div slot-scope="props" class="flex-start">
              <!-- <el-avatar
                v-if="props.item.type == 'artist' && image(props.item) !== null"
                :src="image(props.item)"
                @error="errorHandler"
                class="mr10 mb10"
              >
                <img src="@/assets/images/no_image.png" />
              </el-avatar> -->
              <span v-if="props.item.type == 'track'">
                {{ props.item.artist_name }} - {{ props.item.title }}
              </span>
              <span v-else>
                {{ props.item.name }}
              </span>
            </div>
          </el-autocomplete>
        </div>
      </li>
    </el-menu>
  </el-header>
</template>

<script>
import axios from '@/plugins/axios'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('labelArtist', ['artists'])
  },

  data() {
    return {
      search: '',
      url: process.env.VUE_APP_STORAGE_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      switch: false
    }
  },

  methods: {
    ...mapMutations('auth', ['setToggle']),
    ...mapMutations('artistDashboard', [
      'setSelectedArtist',
      'setSelectedTrack'
    ]),
    ...mapActions('labelArtist', ['read']),
    toggle() {
      this.switch = !this.switch
      this.setToggle(this.switch)
    },
    remoteMethod(query, callback) {
      let dummy = {
        id: null,
        name: 'No result',
        type: 'dummy'
      }
      query = query.trim()
      if (query !== '') {
        query = query
          .replace(/[/]/g, '&sol;')
          .replace(/&/g, '&amp;')
          .replace(/>/g, '&gt;')
          .replace(/</g, '&lt;')
          .replace(/"/g, '&quot;')
        axios.label
          .get(`search/${query}`)
          .then(response => {
            let links = response.data.data
            if (links.length > 0) {
              callback(links)
            } else {
              callback(new Array(dummy))
            }
          })
          .catch(() => {
            this.$message({
              message: 'Search error, please try again',
              type: 'error'
            })
          })
      } else {
        callback(new Array(dummy))
      }
    },
    handleSelect(data) {
      this.setSelectedArtist(null)
      this.setSelectedTrack(null)
      if (data.type == 'artist') {
        this.setSelectedArtist(data)
        this.$router.push(`/label/my-artists/artist`)
      } else if (data.type == 'track') {
        /*let artist = {
          id: data.artist_id,
          name: data.artist_name,
          file_name: data.file_name
        }
        this.setSelectedArtist(artist)
        this.setSelectedTrack(data)*/
        this.$router.push('/artist/my-tracks/track-details?track=' + data.id)
      }
      this.search = ''
    },
    openProfile() {
      this.$router.push('/label/profile')
    },
    errorHandler() {
      return true
    },
    image(item) {
      if (item.file_name !== null) {
        return this.url + 'artists/' + item.file_name
      } else return null
    },
    openDashboard() {
      this.setSelectedArtist(null)
      this.setSelectedTrack(null)
      this.$router.push('/label/home')
    },
    openArtists() {
      this.setSelectedArtist(null)
      this.setSelectedTrack(null)
      this.$router.push('/label/my-artists')
    },
    openArtist(artist) {
      if (!artist.id) return false
      this.setSelectedArtist(artist)
      this.$router.push(`/label/my-artists/artist`)
    },
    labelLogout() {
      this.setSelectedArtist(null)
      this.setSelectedTrack(null)
      this.logout('label')
    }
  },
  created() {
    this.read()
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  position: fixed;
  z-index: 110;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  .el-button.is-circle {
    background: #e6e5e8;
    border: #e6e5e8;
  }
}

.el-icon-s-data,
.el-icon-mic {
  color: #ffffff;
}

.logo {
  #logo {
    padding: 0 1rem 0 2rem;
  }
}

.log-out {
  padding: 0 2.4rem 0 1.4rem !important;
}

.avatar {
  padding: 0;
  &:hover {
    background-color: none;
  }
}

.dropdown-item {
  height: 45px !important;
  border: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white !important;
  i {
    color: #666666;
  }
  &:hover {
    background-color: #eeebeb !important;
    i {
      color: #444444;
    }
  }
}

.el-menu--horizontal > .el-submenu .el-submenu__title,
.el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
  font-size: 16px;
  &:hover {
    border-bottom: none !important;
    background-color: transparent !important;
  }
}

.my-artists {
  .el-button.is-circle {
    margin-right: 7px;
  }
  span {
    margin: 0;
    font-size: 16px;
    color: white;
  }
}

.el-menu {
  height: 90px;
  .el-menu-item,
  .el-submenu {
    line-height: 90px;
    height: 90px;
    border-bottom: none;
    padding: 0 0 0 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: white;
    }
  }
}
</style>
